import PublicLayout from '../../layouts/PublicLayout';
import { Modal } from "react-bootstrap";


const AgencyReviewReview = (props) => {

	return (
        <>
            <Modal.Header style={{'border': '0px'}} closeButton onClick={props.closeModal}></Modal.Header>
			<Modal.Body>
			<p className="text-center">You are trying to write a review from wrong account</p>
			<p className="text-center">You will need to logout and create a separate user account with a different email address to send and receive messages in this way</p>
			</Modal.Body>	
        </>	
	)
}


AgencyReviewReview.Layout = PublicLayout;

export default AgencyReviewReview
